import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  acceptAssistedClockOut,
  editTimecard,
} from 'features/timesheets/TimesheetsPage/TimecardModal/slices';

import Issue from './Issue';

const LateClockOut = ({ issue, onChangeShift, shift, setChangesMade }) => {
  const dispatch = useDispatch();
  const handleClick = useCallback(() => {
    dispatch(editTimecard());
    setChangesMade(true);

    if (shift.get('scheduled')) {
      onChangeShift('actual_end_at', shift.get('scheduled_end_at'));
    }
  }, [dispatch, onChangeShift, setChangesMade, shift]);

  const handleDismissClick = useCallback(() => {
    dispatch(
      acceptAssistedClockOut({
        id: shift.get('id'),
        originPath: window.location.pathname,
      })
    );
  }, [dispatch, shift]);

  return (
    <Issue
      issue={issue}
      onClick={handleClick}
      onDismissClick={handleDismissClick}
    />
  );
};

export default LateClockOut;
